
import { Button } from '@progress/kendo-react-buttons'
import { DateTimePicker } from '@progress/kendo-react-dateinputs'
import { ComboBox, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns'
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from '@progress/kendo-react-form'
import { Checkbox, Input } from '@progress/kendo-react-inputs'
import { MouseEvent as ReactMouseEvent, useEffect, useState } from 'react'
import SessionStorageService from '../../services/SessionStorageService'
import {
  concelhos,
  distritos,
  entidades,
  estadoCandidatura,
  fillCombosAuxiliares,
  fillEstadoCandidaturaAsync,
  fillInstrumentoFinanciamentoAsync,
  fillTipoIncidenciaAsync,
  freguesias,
  hasPermission,
  instrumentoFinanciamento,
  instrumentoPlaneamento,
  nuts1,
  nuts2,
  nuts3,
  post,
  tecnicos,
  tipoIncidencia,
  useCombos,
  userLoggedObject
} from '../../services/utils'
import styles from '../../styles/intervencao/Intervencao.module.scss'
import { AUTH_LOCALSTORAGE, CONSULTAR_CANDIDATURA, PERMISSION_INTERVENCAO_PERFIL_BASICO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_TOTAL } from '../../utils/constants'
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query'
import ReactGA from 'react-ga4';

const getCandidatura = async (data: any) => await post<any, any>(`${CONSULTAR_CANDIDATURA}`, data)

type Props = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  onClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
}

export default function PesquisarCandidatura({ onClick, }: Props) {
  const [identificacaoVisible, setIdentificacaoVisible] = useState(false)
  const toggleIdentificacao = () =>
    setIdentificacaoVisible((previousState) => !previousState)

  const [registoVisible, setRegistoVisible] = useState(true)
  const toggleRegisto = () =>
    setRegistoVisible((previousState) => !previousState)

  const [criterioGeograficoVisible, setCriterioGeograficoVisible] =
    useState(false)
  const toggleCriterioGeografico = () => {
    setCriterioGeograficoVisible((previousState) => !previousState)
  }

  const [localizacaoVisible, setLocalizacaoVisible] = useState(false)
  const toggleLocalizacao = () => {
    setLocalizacaoVisible((previousState) => !previousState)
  }

  const [dataVisible, setDataVisible] = useState(false)
  const toggleData = () => {
    setDataVisible((previousState) => !previousState)
  }

  const [fonteFincaceiraVisible, setFonteFinanceiraVisible] = useState(false)
  const toggleFonteFinanceira = () => {
    setFonteFinanceiraVisible((previousState) => !previousState)
  }

  const [instrumentoFinanciamentoVisible, setInstrumentoFinanciamentoVisible] =
    useState(false)
  const toggleInstrumentoFinanciamento = () => {
    setInstrumentoFinanciamentoVisible((previousState) => !previousState)
  }

  const [investimentoVisible, setInvestimentoVisible] = useState(false)
  const toggleInvestimento = () => {
    setInvestimentoVisible((previousState) => !previousState)
  }

  const [estadoVisible, setEstadoVisible] = useState(false)
  const toggleEstado = () => {
    setEstadoVisible((previousState) => !previousState)
  }

  const [concelhosFiltred, setConcelhosFiltred] = useState<any>(undefined)
  const [concelhosDisabled, setConcelhosDisabled] = useState<any>(true)
  const [freguesiasFiltred, setFreguesiasFiltred] = useState<any>(undefined)
  const [freguesiasDisabled, setFreguesiasDisabled] = useState<any>(true)
  const [nuts2Filtered, setNuts2Filtered] = useState<any>(undefined)
  const [nuts2Disabled, setNuts2Disabled] = useState<any>(true)
  const [nuts3Filtered, setNuts3Filtered] = useState<any>(undefined)
  const [nuts3Disabled, setNuts3Disabled] = useState<any>(true)
  const [minData, setMinDate] = useState<any>();
  const [tecnicosData, setTecnicosData] = useState(tecnicos ? tecnicos.slice() : []);
  const [entidadesData, setEntidadesData] = useState(entidades ? entidades.slice() : []);


  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/PesquisarIntCandidatura" });
  }, []);

 useEffect(() => {

     if(!estadoCandidatura)
     {
      fillEstadoCandidaturaAsync();
     }
     if(!instrumentoFinanciamento )
      {
      fillInstrumentoFinanciamentoAsync();
      }
      if(!tipoIncidencia){
        fillTipoIncidenciaAsync();
      }


  }, []);

  const filterConcelho = (e: any) => {
    if (e?.value?.codigo) {
      const concelhosLocal = concelhos.filter(
        (x: any) => x.distrito_cod == e.value.codigo
      )
      setConcelhosFiltred(concelhosLocal)
      setConcelhosDisabled(false)
    } else {
      setConcelhosFiltred(concelhos)
      setConcelhosDisabled(true)
    }
  }

  const filterFreguesia = (e: any) => {
    if (e?.value?.codigo) {
      const freguesiaLocal = freguesias.filter(
        (x: any) => x.concelho_cod == e.value.codigo
      )
      setFreguesiasFiltred(freguesiaLocal)
      setFreguesiasDisabled(false)
    } else {
      setFreguesiasDisabled(true)
      setFreguesiasFiltred(freguesias)
    }
  }

  const filterNuts2 = (e: any) => {
    if (e?.value?.codigo) {
      const nutsLocal = nuts2.filter((x: any) => x.nuts_i_cod == e.value.codigo)
      setNuts2Filtered(nutsLocal)
      setNuts2Disabled(false)
    } else {
      setNuts2Disabled(true)
      setNuts2Filtered(nuts2)
    }
  }

  const filterNuts3 = (e: any) => {
    if (e?.value?.codigo) {
      const nutsLocal = nuts3.filter(
        (x: any) => x.nuts_ii_cod == e.value.codigo
      )
      setNuts3Filtered(nutsLocal)
      setNuts3Disabled(false)
    } else {
      setNuts3Disabled(true)
      setNuts3Filtered(nuts3)
    }
  }
  const [dataRegistoDe, setDataRegistoDe] = useState('');
  const [dataSubmissaoDe, setDataSubmissaoDe] = useState('');

  const loggedUser = userLoggedObject();
  
  const handleSubmit = async (e: any) => {

    postMessage({ type: 'showLoader' }, '*')

    const objToSearch = {
      id: e.values?.id?.trim() == "" ? undefined : e.values?.id,
      designacao: e.values?.designacao ?? undefined,
      cod_candid: e.values?.cod_candid ?? undefined,
      valor_candid: e.values?.valor_candid ?? undefined,
      valor_comp: e.values?.valor_comp ?? undefined,
      de_valor_total: e.values?.de_valor_total ?? undefined,
      ate_valor_total: e.values?.ate_valor_total ?? undefined,
      id_tipo_in: e.values?.id_tipo_in?.id ?? undefined,
      status: e.values?.status ?? undefined,
      data_registo: e.values?.data_registo ?? undefined,
      de_data_registo: e.values?.de_data_registo ?? undefined,
      ate_data_registo: e.values?.ate_data_registo ?? undefined,
      data_submissao: e.values?.data_submissao ?? undefined,
      de_data_submissao: e.values?.de_data_submissao ?? undefined,
      ate_data_submissao: e.values?.ate_data_submissao ?? undefined,
      instr_financiamento_id: e.values?.instr_financiamento_id?.id ?? undefined,
      estado_candidatura_id: e.values?.estado?.id ?? undefined,
      entidade_id : e.values?.entidade?.id ?? undefined,
      utilizador_id : e.values?.tecnico_responsavel?.id,
      filedoc_cod: e.values?.numero_processo_filedoc ?? undefined,
      entidadeAssociada : loggedUser?.user?.entidadeId,
      id_user_logged: loggedUser?.user?.id,


    }
          
    SessionStorageService.setItem("lastSearchCandidatura", objToSearch);
    const result: any = await getCandidatura(objToSearch);

    //if (result) {
      SessionStorageService.setItem('resultadoCandidaturaPesquisa', result)
      postMessage({ type: 'resultadoCandidaturaPesquisaChange', value: result }, '*')
    //}
    SessionStorageService.setItem("firstCallCandidatura", true);

  }

   type combosKeys = 'instrumentoFinanciamento'
  |'estadoCandidatura' | 'tipoIncidencia' | 'entidades';

  const [combos, setCombos] = useState<any>({
    estadoCandidatura, 
    instrumentoFinanciamento,
    tipoIncidencia
  })
  const setDataOption: Record<combosKeys, { setFn: any, data: any[] }> = {
    estadoCandidatura: {
      setFn: setCombos,
      data: estadoCandidatura
    },
    instrumentoFinanciamento: {
      setFn: setCombos,
      data: instrumentoFinanciamento
    },
    tipoIncidencia: {
      setFn: setCombos,
      data: tipoIncidencia
    },
    entidades: {
      setFn: setCombos,
      data: entidades
    },
  };

  const filterCombo_Multiselect = (e: any, tipoCombo: combosKeys) => {
    const { setFn, data } = setDataOption[tipoCombo];
    setFn({
        ...combos,
        [tipoCombo]: filterBy(data?.slice()??[], e.filter)
    });
}

const filterDataTecnicos = (filter: FilterDescriptor) => {
  const data = tecnicos.slice();
  return filterBy(data, filter);
};

const filterChangeEntidades = (event: ComboBoxFilterChangeEvent) => {
  setEntidadesData(filterDataEntidades(event.filter));
};

const filterDataEntidades = (filter: FilterDescriptor) => {
  const data = entidades.slice();
  return filterBy(data, filter);
};

const filterChangeTecnicos = (event: ComboBoxFilterChangeEvent) => {
  setTecnicosData(filterDataTecnicos(event.filter));
};


const canSeeCandidatura = hasPermission(PERMISSION_INTERVENCAO_PERFIL_BASICO) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL);



  return (
    <Form
      onSubmitClick={handleSubmit}
      render={(formRenderProps: FormRenderProps) => (
        <>
          <FormElement className={styles.form}>
            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleRegisto}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        registoVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    />
                  </div>
                  <span className={styles.fieldsetTitulo}>Registo</span>
                </button>
              </legend>

              {registoVisible && (
                <div className={styles.espacoVerticalFieldSet}>
                  <div className={styles.fields}>
                    <div>
                      <Field name="id" label="ID" component={Input} />
                    </div>

                    <div>
                      <Field
                        name="estado"
                        label="Estado"
                        component={ComboBox}
                        textField={'descricao'}
                        data={combos?.estadoCandidatura}
                        filterable={true}
                        onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'estadoCandidatura')}}
                      />
                    </div>

                    <div>
                      <Field
                        name="numero_processo_filedoc"
                        label="N.º de processo APA"
                        component={Input}
                        textField={'descricao'}
                        maxLength={250}
                      />
                    </div>
                  </div>
                  <div className={styles.fields}>
                  <div>
                      <Field
                        name="tecnico_responsavel"
                        label="Técnico de registo"
                        component={ComboBox}
                        textField={'userName'}
                        filterable={true}
                        onFilterChange={filterChangeTecnicos}
                        data={tecnicosData}
                      />
                    </div>
                    <div>
                      <Field
                        name="entidade"
                        label="Entidade"
                        component={ComboBox}
                        textField={'nome'}
                        filterable={true}
                        onFilterChange={filterChangeEntidades}
                        data={entidadesData}
                      />
                    </div>
                  </div>
                  
                  <div className={styles.fields}>
                    <div>
                      <Field
                        name="de_data_registo"
                        label="data registo de"
                        component={DateTimePicker}
                        format="dd/MM/yyyy HH:mm"
                        onChange={(e) => {
                          setDataRegistoDe(e.value)
                           setMinDate(e.value);
                        }}                        />
                    </div>
                    <div>
                      <Field
                        name="ate_data_registo"
                        label="data registo até"
                        component={DateTimePicker}
                        format="dd/MM/yyyy HH:mm"
                        min={minData}
                      />
                    </div>
                  </div>
                </div>
              )}
            </fieldset>
            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleIdentificacao}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        identificacaoVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    />
                  </div>
                  <span className={styles.fieldsetTitulo}>
                    Identificação
                  </span>
                </button>
              </legend>
              {identificacaoVisible && (
                <div className={styles.espacoVerticalFieldSet}>
                  <div className={styles.fields}>
                  <div>
                      <Field
                        name="designacao"
                        label="Designação"
                        component={Input}
                        maxLength={255}
                      />
                    </div>
                  
                    
                    <div>
                        <Field
                          name="cod_candid"
                          label="N.º de candidatura"
                          component={Input}
                          maxLength={50}
                        />
                    </div>
                  </div>
                  <div className={styles.fields}>
                    <div>
                      <Field
                        name="de_data_submissao"
                        label="Data submissão de"
                        component={DateTimePicker}
                        format="dd/MM/yyyy HH:mm"
                        onChange={(e) => {
                          setDataSubmissaoDe(e.value)
                           setMinDate(e.value);
                        }}                        />
                    </div>
                    <div>
                      <Field
                        name="ate_data_submissao"
                        label="Data submissão até"
                        component={DateTimePicker}
                        format="dd/MM/yyyy HH:mm"
                        min={minData}
                      />
                    </div>
                  </div>
                  <div className={styles.espacoVerticalFieldSet}>
                  <legend className={styles.fieldsetSubTituloInvestimento}>Investimento previsto total</legend>
                  <div className={styles.fields}>
                    <div>
                      <Field name="de_valor_total" label="De" component={Input} maxLength={25}/>
                    </div>
                    <div>
                      <Field name="ate_valor_total" label="Até" component={Input} maxLength={25}/>
                    </div>
                  </div>
                </div>
                </div>
              )}
            </fieldset>
            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleFonteFinanceira}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        fonteFincaceiraVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    />
                  </div>
                  <span className={styles.fieldsetTitulo}>
                    Tipologia
                  </span>
                </button>
              </legend>
              {fonteFincaceiraVisible && (
                <div className={styles.espacoVerticalFieldSet}>
                  <div className={styles.fields}>
                  <Field
                    name="id_tipo_in"
                    label="Tipo de Incidência"
                    component={ComboBox}
                    textField={'descricao'}
                    filterable={true}
                    data={combos?.tipoIncidencia}            
                    onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'tipoIncidencia')}}        
                  />
                  </div>
                </div>
              )}
            </fieldset>
            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleInstrumentoFinanciamento}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        instrumentoFinanciamentoVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    />
                  </div>
                  <span className={styles.fieldsetTitulo}>
                    Instrumento de financiamento
                  </span>
                </button>
              </legend>
              {instrumentoFinanciamentoVisible && (
                <div className={styles.espacoVerticalFieldSet}>
                  <div className={styles.fields}>
                    <div>
                      <Field
                        name="instr_financiamento_id"
                        label="Instrumento"
                        component={ComboBox}
                        textField={'designacao'}
                        filterable={true}
                        onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'instrumentoFinanciamento')}}
                        data={combos?.instrumentoFinanciamento}

                      />
                    </div>
                  </div>
                </div>
              )}
            </fieldset>
          </FormElement>

          <div
            className={`${styles.footer} ${styles.justify_multiple_children}`}
          >
            <Button
              onClick={formRenderProps.onFormReset}
              className={styles.btnLimparPesquisa}
              title='Limpar pesquisa'
            >
              <span className="icon-siarl icon-limparcampos"></span>
              <span className={styles.rotulo}>
                {' '}&nbsp;{' '}
                Limpar pesquisa
              </span>              
            </Button>

            <Button
              onClick={formRenderProps.onSubmit}
              className={styles.btnPesquisar}
              title='Pesquisar'
            >
              <span className="icon-siarl icon-pesquisar"></span>
              <span className={styles.rotulo}>
                {' '}&nbsp;{' '}
                Pesquisar
              </span>      
            </Button>
          </div>
        </>
      )}
    />
  )
}
